// extracted by mini-css-extract-plugin
export var option = "_5c-1";
export var optionActive = "_5c-2";
export var pill = "_5c-0";